import translator from '@Components/Utilities/Translator';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import BidderStatusMessage from '@Components/Info/BidderStatusMessage';
import EmbeddedYouTubeVideoThumbnail from '@Components/Shared/EmbeddedYouTubeVideoThumbnail';
import TranslationText from '@Components/Utilities/TranslationText';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';

const CanIBidView = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
   
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                <h1 className='pagename border-bottom'>{props.PageTitle}</h1>
            </div>
            {currentSite.Site.IsLivestockMarket || currentSite.Site.IsEquineMarket ?
                <>
                    {props.BidderStatusMessageModel &&
                        <div className="contact-us-container">
                            <BidderStatusMessage {...props.BidderStatusMessageModel} showFullMessage excludeContactInfo />
                        </div>
                    }
                    <div className="section-container">
                        <h2>{translator.translate('sandhills.tradesites.mvc.biddingonline')}</h2>
                        <div className="section-content-container">
                            <div className="text-section">
                                <p>{translator.translate(props.ATDescTranslationKey)}</p>
                                <p>{translator.translate('sandhills.tradesites.mvc.atbidquestions', [props.ATPhone1, props.ATPhone2])}</p>
                            </div>
                            <div className="video-section">
                                <EmbeddedYouTubeVideoThumbnail
                                    descriptionText={translator.translate('sandhills.tradesites.mvc.registertobidon', ["AuctionTime.com"])}
                                    altText={translator.translate('sandhills.tradesites.mvc.registertobidon', ["AuctionTime.com"])}
                                    videoId={props.YouTubeAuctionTimeBiddingRegistrationVideoID}
                                    onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "CanIBidView_RegisterToBidAT")}
                                />
                            </div>
                        </div>
                        <h2>{translator.translate('sandhills.tradesites.mvc.biddingonsite')}</h2>
                        <div className="section-content-container">
                            <div className="text-section">
                                <p>{translator.translate(props.EFDescTranslationKey)}</p>
                                <p>{translator.translate('sandhills.tradesites.mvc.bcbidquestions', [props.BCPhone])}</p>
                            </div>
                            <div className="video-section">
                                <EmbeddedYouTubeVideoThumbnail
                                    descriptionText={translator.translate('sandhills.tradesites.mvc.registertobidon', ["EquipmentFacts.com"])}
                                    altText={translator.translate('sandhills.tradesites.mvc.registertobidon', ["EquipmentFacts.com"])}
                                    videoId={props.YouTubeBidCallerBiddingRegistrationVideoID}
                                    onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "CanIBidView_RegisterToBidEF")}
                                />
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    {props.BidderStatusMessageModel &&
                        <div className="contact-us-container">
                            <BidderStatusMessage {...props.BidderStatusMessageModel} showFullMessage />
                        </div>
                    }
                    {props.YouTubeAuctionTimeBiddingRegistrationVideoID &&
                        <div className="youtube-thumbnail-container">
                            <EmbeddedYouTubeVideoThumbnail
                                descriptionText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                altText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                videoId={props.YouTubeAuctionTimeBiddingRegistrationVideoID}
                                onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "CanIBidView_RegisterToBidAT")}
                            />
                        </div>
                    }
                    {props.YouTubeBidCallerBiddingRegistrationVideoID &&
                        <div className="youtube-thumbnail-container">
                            <EmbeddedYouTubeVideoThumbnail
                                descriptionText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                altText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                videoId={props.YouTubeBidCallerBiddingRegistrationVideoID}
                                onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "CanIBidView_RegisterToBidEF")}
                            />
                        </div>
                    }
                    {props.YouTubePreBiddingVideoID &&
                        <div className="youtube-thumbnail-container">
                            <h2><TranslationText tKey='sandhills.tradesites.mvc.howtoprebid' /></h2>
                            <EmbeddedYouTubeVideoThumbnail
                                descriptionText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                altText={translator.translate('sandhills.learnmoreabouttheregistrationprocess')}
                                videoId={props.YouTubePreBiddingVideoID}
                                onOpen={() => gtmPushEvent(gtmEventType.youtube_thumbnail, 'videoName', "CanIBidView_PreBidding")}
                            />
                        </div>
                    }
                </>}
        </div>
    );
};

export default CanIBidView;
global.CanIBidView = CanIBidView;